import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const GensNumbers = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="gens-numbers">
                <CommonSmallTitle>
                    <a
                        className="gens-numbers__link gens__link"
                        href="https://generation-startup.ru/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        GenerationS
                    </a>
                </CommonSmallTitle>
                <CommonSmallText className="gens-numbers__info">
                    Это платформа по&nbsp;развитию корпоративных инноваций, первый российский
                    акселератор в&nbsp;международной сети Global Accelerator Network (GAN), который
                    вошел в&nbsp;рейтинг ТОП-5 государственных акселераторов в&nbsp;мире
                    по&nbsp;версии UBI Global.
                </CommonSmallText>
                <CommonSmallTitle className="gens-numbers__subtitle">
                    Платформа в цифрах
                </CommonSmallTitle>
                <div className="gens-numbers__items">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gens-numbers__item-body"
                    >
                        <div className="gens-numbers__item-title">16&nbsp;000+</div>
                        <CommonSmallText className="gens-numbers__item-subtitle">
                            Стартапов с&nbsp;момента запуска платформы
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gens-numbers__item-body"
                    >
                        <div className="gens-numbers__item-title">7,4&nbsp;млрд.</div>
                        <CommonSmallText className="gens-numbers__item-subtitle">
                            Общий объем инвестиций выпускников
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="gens-numbers__item-body"
                    >
                        <div className="gens-numbers__item-title">251+</div>
                        <CommonSmallText className="gens-numbers__item-subtitle">
                            Партнерская сеть вузов и&nbsp;региональных технопарков
                        </CommonSmallText>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default GensNumbers;
